export const GTM_GLOBAL = {
  ID: {},
  EVENT: {
    ga_registration_interrupted: 'ga_registration_interrupted',
  },
}

export const GTM_REG_BONUS = {
  ID: {
    ga_deposit_click_close: 'ga_deposit_click_close',
    ga_deposit_click_btn_nobonus: 'ga_deposit_click_btn_nobonus',
    ga_deposit_click_btn_continue: 'ga_deposit_click_btn_continue',
  },
  EVENT: {
    ga_deposit_popup_show: 'ga_deposit_popup_show',
    ga_deposit_choose_deposit_successful: 'ga_deposit_choose_deposit_successful',
    ga_deposit_click_activate_successful: 'ga_deposit_click_activate_successful',
    ga_deposit_click_activate_errors: 'ga_deposit_click_activate_errors',
  },
}

export const GTM_REG = {
  ID: {
    ga_registration_click_btn_apple: 'ga_registration_click_btn_apple',
    ga_registration_click_btn_google: 'ga_registration_click_btn_google',
    ga_registration_click_btn_login: 'ga_registration_click_btn_login',
    ga_registration_click_btn_registration: 'ga_registration_click_btn_registration',
    ga_registration_click_btn_choose_methode: 'ga_registration_click_btn_choose_methode',
    ga_registration_click_input_email: 'ga_registration_click_input_email',
    ga_registration_click_input_phone: 'ga_registration_click_input_phone',
    ga_registration_click_input_password: 'ga_registration_click_input_password',
    ga_registration_click_close: 'ga_registration_click_close',
  },
  EVENT: {
    ga_registration_popup_show: 'ga_registration_popup_show',
    ga_registration_successful: 'ga_registration_successful',
  },
}

export const GTM_CASHBOX = {
  ID: {
    ga_cashbox_click_btn_deposite: 'ga_cashbox_click_btn_deposite',
    ga_cashbox_click_btn_withdrawal: 'ga_cashbox_click_btn_withdrawal',
    ga_cashbox_сlick_btn_history: 'ga_cashbox_click_btn_history',
    ga_cashbox_click_close: 'ga_cashbox_click_close',
    ga_cashbox_click_btn_choose_payment_method: 'ga_cashbox_click_btn_choose_payment_method',
    ga_cashbox_сlick_btn_amount: 'ga_cashbox_сlick_btn_amount',
    ga_cashbox_click_btn_pay: 'ga_cashbox_click_btn_pay',
    ga_cashbox_click_btn_verification: 'ga_cashbox_click_btn_verification',
  },
  EVENT: {
    ga_cashbox_popup_show: 'ga_cashbox_popup_show',
    ga_cashbox_increment: 'ga_cashbox_increment',
    ga_cashbox_decrement: 'ga_cashbox_decrement',
    ga_cashbox_verification_popup_show: 'ga_cashbox_verification_popup_show',
  },
}

export const GTM_LEVEL = {
  ID: {
    ga_level_click_close: 'ga_level_click_close',
    ga_level_click_btn_verification: 'ga_level_click_btn_verification',
    ga_level_click_btn_about_level: 'ga_level_click_btn_about_level',
  },
  EVENT: {
    ga_level_popup_show: 'ga_level_popup_show',
  },
}

export const GTM_VERIF_DOC = {
  ID: {
    ga_verification_click_close: 'ga_verification_click_close',
    ga_verification_click_btn_document: 'ga_verification_click_btn_document',
    ga_verification_doc_click_btn_privat24: 'ga_verification_doc_click_btn_privat24',
    ga_verification_doc_click_btn_monobank: 'ga_verification_doc_click_btn_monobank',
    ga_verification_doc_click_btn_diya: 'ga_verification_doc_click_btn_diya',
    ga_verification_doc_click_btn_bankid: 'ga_verification_doc_click_btn_bankid',
    ga_verification_doc_click_btn_loaddocs: 'ga_verification_doc_click_btn_loaddocs',
    ga_verification_doc_click_btn_familiarize: 'ga_verification_doc_click_btn_familiarize',
  },
  EVENT: {
    ga_verification_popup_show: 'ga_verification_popup_show',
  },
}

export const GTM_VERIF_LIMIT = {
  ID: {
    /** deposit */
    ga_verification_limits_depolimit_click_btn_unlimited: 'ga_verification_limits_depolimit_click_btn_unlimited',
    ga_verification_limits_depolimit_click_btn_day: 'ga_verification_limits_depolimit_click_btn_day',
    ga_verification_limits_depolimit_day_input: 'ga_verification_limits_depolimit_day_input',
    ga_verification_limits_depolimit_click_btn_week: 'ga_verification_limits_depolimit_click_btn_week',
    ga_verification_limits_depolimit_week_input: 'ga_verification_limits_depolimit_week_input',
    ga_verification_limits_depolimit_click_btn_month: 'ga_verification_limits_depolimit_click_btn_month',
    ga_verification_limits_depolimit_month_input: 'ga_verification_limits_depolimit_month_input',
    /** gameWeek */
    ga_verification_limits_gamelimitweek_click_btn_unlimited: 'ga_verification_limits_gamelimitweek_click_btn_unlimited',
    ga_verification_limits_gamelimitweek_click_btn_setuptime: 'ga_verification_limits_gamelimitweek_click_btn_setuptime',
    ga_verification_limits_gamelimitweek_input: 'ga_verification_limits_gamelimitweek_input',
    /** gameDay */
    ga_verification_limits_gamelimitday_click_btn_unlimited: 'ga_verification_limits_gamelimitday_click_btn_unlimited',
    ga_verification_limits_gamelimitday_click_btn_setuptime: 'ga_verification_limits_gamelimitday_click_btn_setuptime',
    ga_verification_limits_gamelimitday_input: 'ga_verification_limits_gamelimitday_input',
    /** tooltip */
    ga_verification_limits_click_btn_depolimit_tooltip: 'ga_verification_limits_click_btn_depolimit_tooltip',
    ga_verification_limits_click_btn_gamelimitday_tooltip: 'ga_verification_limits_click_btn_gamelimitday_tooltip',
    ga_verification_limits_click_btn_gamelimitweek_tooltip: 'ga_verification_limits_click_btn_gamelimitweek_tooltip',
    /** other */
    ga_verification_limits_setuplimit_click_btn_setuplimit: 'ga_verification_limits_setuplimit_click_btn_setuplimit',
    ga_verification_limits_setuplimit_click_btn_goon: 'ga_verification_limits_setuplimit_click_btn_goon',
    ga_verification_click_btn_limits: 'ga_verification_click_btn_limits',
    ga_verification_limits_click_btn_goon: 'ga_verification_limits_click_btn_goon',
  },
  EVENT: {
    ga_verification_limits_setuplimit_show_popup: 'ga_verification_limits_setuplimit_show_popup',
    ga_verification_limits_setuplimit_show_popup_success: 'ga_verification_limits_setuplimit_show_popup_success',
    ga_verification_limits_setuplimit_cancel: 'ga_verification_limits_setuplimit_cancel',
    ga_verification_limits_success: 'ga_verification_limits_success', // type, limit, delimiter
  },
}

export const GTM_VERIF_EMAIL = {
  ID: {
    ga_verification_click_btn_email: 'ga_verification_click_btn_email',
    ga_verification_email_click_btn_verification: 'ga_verification_email_click_btn_verification',
    ga_verification_email_verif_click_btn_verificationpassword: 'ga_verification_email_verif_click_btn_verificationpassword',
    ga_verification_email_verif_click_btn_sendmore: 'ga_verification_email_verif_click_btn_sendmore',
    ga_verification_email_verif_click_btn_changeemail: 'ga_verification_email_verif_click_btn_changeemail',
    ga_verification_email_input: 'ga_verification_email_input',
    ga_verification_email_cod_input: 'ga_verification_email_cod_input',
  },
  EVENT: {
    ga_verification_email_success: 'ga_verification_email_success',
    ga_verification_email_rejected: 'ga_verification_email_rejected',
  },
}

export const GTM_VERIF_PHONE = {
  ID: {
    ga_verification_click_btn_phone: 'ga_verification_click_btn_phone',
    ga_verification_phone_input: 'ga_verification_phone_input',
    ga_verification_phone_click_bnt_sendcodverification: 'ga_verification_phone_click_bnt_sendcodverification',
  },
  EVENT: {
    ga_verification_phone_rejected: 'ga_verification_phone_rejected',
    ga_verification_phone_success: 'ga_verification_phone_success',
  },
}
